import './AddBedManually.scss'
import AddBedManually from "./AddBedManually";

export default AddBedManually;